import React from 'react';
import { Dropdown, Menu, Modal, message } from 'antd';
import './TemplateCardMenu.css';
import { templateService } from '../../../../Api/api';

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const TemplateCardMenu = ({ templateId, onDeleted }) => {
  const handleDelete = () => {
    Modal.confirm({
      icon: null,
      title: null,
      content: (
        <div className="tcm-modal-body">
          <div className="tcm-modal-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
              stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M10 11v6" /><path d="M14 11v6" />
              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
            </svg>
          </div>
          <div className="tcm-modal-text">
            <p className="tcm-modal-title">Delete Template</p>
            <p className="tcm-modal-desc">Are you sure you want to delete this template? This action cannot be undone.</p>
          </div>
        </div>
      ),
      okText: 'Delete',
      okType: 'primary',
      okButtonProps: {
        className: 'tcm-modal-ok-btn',
        style: { backgroundColor: '#526bb1', borderColor: '#526bb1', borderRadius: '6px', fontWeight: 500 },
      },
      cancelButtonProps: {
        style: { borderRadius: '6px', fontWeight: 500 },
      },
      cancelText: 'Cancel',
      centered: true,
      className: 'tcm-delete-modal',
      onOk: async () => {
        try {
          await templateService.deleteTemplate(templateId);
          message.success('Template deleted successfully');
          if (onDeleted) onDeleted(templateId);
        } catch (error) {
          message.error('Failed to delete template');
        }
      },
    });
  };

  const items = [
    {
      key: 'edit',
      label: (
        <span className="tcm-item-content">
          <span className="tcm-item-label">Edit Template</span>
          <span className="tcm-item-icon"><EditIcon /></span>
        </span>
      ),
      onClick: () => window.open(`/template/${templateId}`, '_blank'),
    },
    {
      key: 'delete',
      label: (
        <span className="tcm-item-content">
          <span className="tcm-item-label">Delete Template</span>
          <span className="tcm-item-icon"><DeleteIcon /></span>
        </span>
      ),
      onClick: handleDelete,
    },
  ];

  const menu = (
    <Menu selectable={false} onClick={({ key }) => {
      const item = items.find(i => i.key === key);
      if (item && item.onClick) item.onClick();
    }}>
      {items.map(i => (
        <Menu.Item key={i.key}>{i.label}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="tcm-wrapper" onClick={(e) => e.stopPropagation()}>
      <Dropdown
        overlay={menu}
        trigger={['click']}
        align={{ points: ['tl', 'tr'], offset: [5, -2] }}
        getPopupContainer={() => document.body}
        overlayClassName="tcm-overlay"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="tcm-trigger"
          aria-label="Template actions"
          onClick={(e) => e.stopPropagation()}
        >
          <span className="tcm-trigger-dot" />
          <span className="tcm-trigger-dot" />
          <span className="tcm-trigger-dot" />
        </button>
      </Dropdown>
    </div>
  );
};

export default TemplateCardMenu;